<ng-container *transloco="let t;">
  <p-dialog header="{{ t('common.labels.upload_files') }}" [(visible)]="uploadOpened" [draggable]="false"
    [resizable]="false" modal="true" [style]="{width: '50vw'}">
    <p-fileUpload
      #upload
      [showCancelButton]="false"
      name="myfile[]"
      multiple="multiple"
      [accept]="accept"
      [attr.maxFileSize]="app.getServerSetting('max_upload_size')"
      customUpload="true"
      (uploadHandler)="onUploadFiles($event)"
      [chooseLabel]="t('common.labels.choose')"
      [showUploadButton]="false"
      [invalidFileSizeMessageSummary]="t('common.messages.invalidFileSizeMessageSummary')"
      [invalidFileSizeMessageDetail]="t('common.messages.invalidFileSizeMessageDetail')"
      [invalidFileTypeMessageSummary]="t('common.messages.invalidFileTypeMessageSummary')"
      [invalidFileTypeMessageDetail]="t('common.messages.invalidFileTypeMessageDetail')"
      [invalidFileLimitMessageDetail]="t('common.messages.invalidFileLimitMessageDetail')"
      [invalidFileLimitMessageSummary]="t('common.messages.invalidFileLimitMessageSummary')"
    >
      <ng-template pTemplate="content" let-files>
        <div *ngIf="files.length === 0" style="text-align: center;">{{ t('common.labels.choose_files') }}</div>
      </ng-template>
    </p-fileUpload>

    <p-footer>
      <button *ngIf="submitting !== true" pButton (click)="onStartUpload()" type="button" label="{{ t('common.labels.upload') }}" icon="pi pi-upload" class="p-button-success"></button>
      <button *ngIf="submitting === true" pButton type="button" label="{{ t('common.labels.upload') }}" icon="pi pi-upload" class="p-button-success" disabled="true"></button>
    </p-footer>
  </p-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.upload')"
    [mode]="'template'"
    [(visible)]="uploadInheritVisible"
    (okClicked)="uploadFiles($event)"
  ></app-inherit-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.delete')"
    [mode]="'template'"
    [(visible)]="deleteInheritVisible"
    (okClicked)="deleteFile($event)"
  ></app-inherit-dialog>

</ng-container>
